import script from "./SmartPhoneLoginButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartPhoneLoginButton.vue?vue&type=script&setup=true&lang=ts"

import "./SmartPhoneLoginButton.vue?vue&type=style&index=0&id=109c2f42&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-109c2f42"]])

export default __exports__